import { TopToolbar, useListContext, usePermissions } from "react-admin";
import CustomExportButton from "../unit/CustomExportButton";
import ProductCreate from "./ProductCreate";
import CustomFilterButton from "../unit/CustomFilterButton";
const ProductListActions = ({ ...props }) => {
  const selected = props.selected;
  const { total } = useListContext();
  const { permissions } = usePermissions();

  return (
    <>
      <TopToolbar sx={{ width: "100%" }}>
        <ProductCreate />
        <CustomFilterButton />
        <CustomExportButton />
      </TopToolbar>
    </>
  );
};

export default ProductListActions;
